module.exports = __webpack_public_path__ + "img/remove_background.9862d0b7.png";